import PropTypes from 'prop-types';
import React from 'react';

export const PreserveProfitWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'PRESERVE_PROFIT',
    category: 'Exit',
    type: 'Preserve Profit',
    domain: 'Profit/Loss',
  };
  const state = softOrder.state;
  const amount = softOrder.amount;
  const priceToBreak = softOrder.priceToBreak;

  return (
    <Component details={details} state={state} amount={amount} priceToBreak={priceToBreak} {...rest}/>
  );
};

PreserveProfitWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    amount: PropTypes.any,
    priceToBreak: PropTypes.any,
    state: PropTypes.any
  })
};

